import React from "react";
import { connect } from "react-redux";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        project: store.project,
        loggedUser: store.loggedUser
    }
})

class Type extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: [
                { value: 2, label: "Internal" },
                { value: 3, label: "Private" }
            ]
        }

        _.map(["onRenderOption", "onRenderSelected"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onRenderOption(option) {
        const { loggedUser } = this.props;

        return (
            <div class="project-type-container">
                {option.value === 2 && (
                    <div class="icon-container">
                        <img src="/images/cloudcfo-logo-colored-icon-only.png" style={{width: '23px', marginRight: '2px'}} />
                    </div>
                )}
                {option.value === 3 && (
                    <div class="icon-container">
                        <Avatar id={loggedUser.data.id} name={`${loggedUser.data.firstName} ${loggedUser.data.lastName}`} disableTooltip={true}  />
                    </div>
                )}
                {option.label}
            </div>
        );
    }

    onRenderSelected(option) {
        const { loggedUser } = this.props;

        return (
            <div class="project-type-container">
                {option.value === 2 && (
                    <div class="icon-container">
                        <img src="/images/cloudcfo-logo-colored-icon-only.png" style={{width: '23px', marginRight: '2px'}} />
                    </div>
                )}
                {option.value === 3 && (
                    <div class="icon-container">
                        <Avatar id={loggedUser.data.id} name={`${loggedUser.data.firstName} ${loggedUser.data.lastName}`} disableTooltip={true}  />
                    </div>
                )}
                {option.label}
            </div>
        );
    }

    render() {
        const { project, loggedUser } = this.props;

        return (
            <div class="formSection">
                <div class="formContainer">
                    <label>Account Type  {project.AddType === "project" && (<sup>*</sup>)}</label>
                    {project.AddType === "company" && (
                        <div class="account-type-container">
                            <i class="material-icons">business</i>
                            <span>Company</span>
                        </div>
                    )}
                    {project.AddType === "project" && (
                        <div class="account-type-container">
                            <Select
                                classes={{ options: "accountTypeOption"}}
                                selected={this.props.selected}
                                onChange={this.props.onSetProjectType}
                                options={this.state.options}
                                renderOption={this.onRenderOption}
                                renderSelected={this.onRenderSelected}
                                isFirstItemSelected={false}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Type;
